const labels = {
  "overviewTitle": "Overview",
  "featuresAndHighlights": "Features and highlights",
  "technicalSpecifications": "Technical specifications",
  "pricingAndPlans": "Pricing and plans",
  "whatsIncluded": "What's included",
  "howItWorks": "How it works"
}

export { labels }
